import classes from './SulotionColumn.module.css'
import StoryLineReport from "../sources/StoryLine"
import SLCReport from "../sources/SLC"

const SolutionColumn = ({ currentAssessment, submission }) => {

    const report = {
        SLCQuestionnaire: SLCReport,
        StorylineQuestionnaire: StoryLineReport
    }

    return <div className={classes.Solution}>{report[currentAssessment?.sourceType]?.[currentAssessment?.assessmentTypeId]?.converSultion(submission)}</div>
}

export default SolutionColumn